import React from "react";
import {useDispatch} from "react-redux";
import {Avatar, Popover} from "antd";
import {userSignOut} from "appRedux/actions/Auth";
import Replace2x from '../../util/Extensions/ReplaceExtension'
import axios from 'util/Api'
import config from "../../util/ApiforContext"
import { UserOutlined } from '@ant-design/icons';
const userId = localStorage.getItem("userId");
const userName = localStorage.getItem("userName");

const UserInfo = () => {
  const userSignOut = (value) => {
    axios.get(`${config.apiUrl}/Auth/Logout?userId=${value?.replace('"','').replace('"','').toString()}`,config.headers)
    .then(res => {
      if(res.data.success==true){
        localStorage.removeItem("token");
        window.location.reload()
      }
      }
    );
  };
  const dispatch = useDispatch(); 

  const userMenuOptions = (
    <ul className="gx-user-popover">
      <li>{Replace2x(userName)}</li>
      <hr></hr>
      <li><a style={{color:'#545454'}} href="/password-change">Şifremi Değiştir</a></li>
      <li  onClick={() => userSignOut(userId?.replace('"','').replace('"','').toString())}>Çıkış Yap
      </li>
    </ul>
  );

  return (
    <Popover overlayClassName="gx-popover-horizantal" placement="bottomRight" content={userMenuOptions}
             trigger="click">
      <Avatar className="gx-avatar-name" style={{backgroundColor:'white'}} icon={<UserOutlined style={{color:'#a70000'}}/>} />
    </Popover>
  )

}

export default UserInfo;
